import { type BentoSatellite, BentoSection } from './bento-section'
import {
  ArquivosMockup,
  ContratoMockup,
  DocumentoMockup,
  PortalMockup,
  RelatorioMockup,
} from './mockups/modules'

/*
 * O que sai do escritório para o cliente. A âncora é o par que ele recebe
 * com mais frequência — o relatório do mês e o portal que fica de pé o
 * projeto inteiro — e os satélites são as peças formais.
 */

const SATELLITES: BentoSatellite[] = [
  {
    body: 'Memoriais, atas e termos escritos a várias mãos, com tabelas de especificação e comentários no ponto exato do texto.',
    title: 'Documentos colaborativos',
    visual: <DocumentoMockup />,
  },
  {
    body: 'Objeto, prazos, honorários e responsabilidade técnica já no esqueleto. As parcelas saem do valor combinado e o cliente assina pelo celular.',
    title: 'Contratos blindados',
    visual: <ContratoMockup />,
  },
  {
    body: 'A versão certa do arquivo certo, com miniatura de verdade e o histórico de revisões que a obra precisa conferir.',
    title: 'Arquivos versionados',
    visual: <ArquivosMockup />,
  },
]

export const EntregaveisBento = () => (
  <BentoSection
    accent="#7a6cb6"
    anchor={
      <div className="grid gap-6 md:grid-cols-2 md:items-start">
        <RelatorioMockup />
        <PortalMockup />
      </div>
    }
    background="bg-white"
    cardBg="bg-[#fafafa]"
    cardBorder="border-[#ececec]"
    heading="O que chega ao cliente sai como obra de arte"
    hrefLabel="Ver tudo dos entregáveis"
    hrefTo="/recursos/entregaveis"
    intro="Relatório mensal, portal do projeto, documentos e contratos. Sai em PDF, link público ou direto no WhatsApp do cliente."
    layout="showcase"
    satellites={SATELLITES}
  />
)
